import { SegmentKey, MarketPlace } from '@amzn/fire-tv-campaign-automation-service';

import targetSegments from '../data/TargetSegments/targetSegments.json';

export interface TargetingConfig {
  name: string;
  id: string;
}

type MarketplaceTargetSegments = Partial<
  Record<MarketPlace, Partial<Record<SegmentKey, TargetingConfig[]>>>
>;

const targetSegmentData = targetSegments as MarketplaceTargetSegments;

export const getTargetSegmentConfiguration = (
  _stage: string,
  marketplace: MarketPlace,
): Partial<Record<SegmentKey, TargetingConfig[]>> => {
  return targetSegmentData[marketplace] ?? {};
};
